<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>

<main class="content-page bg-gray">
    <div class="content text-dark">
        <h2>Integrations</h2>

        <ul class="nav nav-tabs" id="integration-" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link active" id="setup-tab" data-toggle="tab" data-target="#setup" role="tab" aria-controls="setup" aria-selected="true">{{this.lot || ''}} Setup</a>
            </li>
            @if (security.permitted('corporation setup', 'corporate integrations', 'update')) {
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="availability-tab" data-toggle="tab" data-target="#availability" role="tab" aria-controls="availability" aria-selected="false">Availability</a>
                </li>
            }
        </ul>

        <div class="tab-content" id="integration-tab-content">
            <div class="tab-pane fade show active" id="setup" role="tabpanel" aria-labelledby="setup-tab">
                <ul id="integration-setup-list" class="list-group list-group-flush">
                    @for (setup of setups; track setup.id; let i = $index) {
                        <li class="list-group-item">
                            <h4><span class="material-icons">{{iconify(setup.category)}}</span> {{setup.name}} &ndash; Integration Setup</h4>
                            <form id="{{setup.token}}-{{i}}-form">
                                @for (setting of setup.settings; track setting) {
                                    <div class="form-group">
                                        <label for="{{setting.field}}-{{i}}">{{setting.display}}</label>
                                        <div class="input-group">
                                            @if (setting.prefix) {
                                                <div class="input-group-prepend"><span class="input-group-text">{{setting.prefix}}</span></div>
                                            }

                                            <input type="{{setting.type}}" class="form-control" id="{{setting.field}}-{{i}}" name="{{setting.field}}" value="{{setting.value || ''}}" [attr.pattern]="setting.validate" [attr.placeholder]="setting.example || ''" [required]="setting.required" [readonly]="setting.immutable" (keyup)="setupChanged(i, setting.field, $event.target.value)" />

                                            @if (setting.suffix) {
                                                <div class="input-group-append"><span class="input-group-text">{{setting.suffix}}</span></div>
                                            }
                                        </div>
                                        @if (setting.description) {
                                            <span id="{{setting.field}}-{{i}}-help-block" class="form-text text-muted">{{setting.description}}</span>
                                        }
                                    </div>
                                }
                            </form>
                        </li>
                    }
                    @empty {
                        <li class="list-group-item empty"><p>No integrations enabled yet for this corporation. Have your administrator enable one or more integrations to get started.</p></li>
                    }
                </ul>
            </div>

            @if (security.permitted('corporation setup', 'corporate integrations', 'update')) {
                <div class="tab-pane fade" id="availability" role="tabpanel" aria-labelledby="availability-tab">
                    <form [formGroup]="integrationSearch" class="form-row">
                        <div class="form-group col">
                            <div class="input-group">
                                <div class="input-group-append">
                                    <span class="input-group-text"><span class="mdi mdi-magnify search-icon"></span></span>
                                </div>
                                <input autocomplete="off" type="search" class="form-control" id="search" autofocus="true" formControlName="inquiry" />
                            </div>
                        </div>
                    </form>

                    <ul id="integration-availability-list" class="list-group list-group-flush">
                        @for (company of filteredIntegrations; track company.id) {
                            <li class="list-group-item" (click)="toggleAvailability(company.id)">
                                <span class="material-icons" [class.text-primary]="company.enabled">{{iconify(company.category)}}</span>
                                <div>
                                    <h4>{{company.name}}</h4>
                                    @if (company.description && (company.description.length > 0)) {
                                        <p class="subtitle">{{company.description}}</p>
                                    }
                                    @if (company.monthly || company.usage) {
                                        @if (company.monthly) {
                                            <span class="badge badge-light">monthly fees may apply</span>
                                        }
                                        @if (company.usage) {
                                            <span class="badge badge-light">usage fees may apply</span>
                                        }
                                    }
                                </div>
                                <span [class.text-muted]="!company.enabled" [class.text-primary]="company.enabled">{{company.enabled ? 'ON' : 'OFF'}}</span>
                            </li>
                        }
                    </ul>
                </div>
            }
        </div>
    </div>
</main>

<app-footer></app-footer>
